import Commerce from '@chec/commerce.js';

export const commerce = new Commerce(
    "pk_test_226780d20e61bbf280dd72e34b0985b62e008ff0bf36d"
  );